import React, { useEffect, useState } from "react";
import "../styles/Header.css";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineMenuAlt3, HiX } from "react-icons/hi";
import logo from "../images/t.png";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isDesktop = useMediaQuery({ minWidth: 784 });

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [mobileOpen]);

  return (
    <>
      <header className={`header ${isSticky ? "sticky" : ""}`}>
        <div className="header-container">
          <div className="logo">
            <img src={logo} alt="Savannah Shine Hub" />
          </div>

          {isDesktop ? (
            <>
             <nav className="nav">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about-us">About</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/contact-us">Contact</NavLink>
          </nav>

              <div className="header-right">
                <div className="phone">
                  <FaPhoneAlt className="icon" />
                  <span>+254 119 117 744</span>
                </div>

                <button className="cta-btn">Request Service</button>
              </div>
            </>
          ) : (
            <button
              className="mobile-menu-btn"
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
            >
              <HiOutlineMenuAlt3 />
            </button>
          )}
        </div>
      </header>

      <div className={`mobile-menu-overlay ${mobileOpen ? "open" : ""}`}>
        <div className="mobile-menu-top">
          <img src={logo} alt="Savannah Shine Hub" />

          <button
            className="mobile-close-btn"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <HiX />
          </button>
        </div>

        <nav className="mobile-nav">
          <a href="/" onClick={() => setMobileOpen(false)}>Home</a>
          <a href="/about-us" onClick={() => setMobileOpen(false)}>About</a>
          <a href="/services" onClick={() => setMobileOpen(false)}>Services</a>
          <a href="/contact-us" onClick={() => setMobileOpen(false)}>Contact</a>
        </nav>

        <div className="mobile-menu-contact">
          <FaPhoneAlt />
          <span>+254 119 117 744</span>
        </div>

        <a
          href="/services"
          className="mobile-request-btn"
          onClick={() => setMobileOpen(false)}
        >
          Request Service
        </a>
      </div>
    </>
  );
};

export default Header;